import { useAuth } from '../../context/AuthContext';
import { ChevronDownIcon, Bars3Icon } from '@heroicons/react/24/outline';
import { deriveNameFromEmail } from '../../utils/nameFromEmail';

const headerStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600&display=swap');
  .fh { height:60px; min-height:60px; background:#ffffff; border-bottom:1px solid #eaecf4; display:flex; align-items:center; justify-content:space-between; padding:0 24px; font-family:'Sora',sans-serif; flex-shrink:0; z-index:10; }
  .fh-left { display:flex; align-items:center; gap:8px; }
  .fh-breadcrumb { font-size:.8rem; color:#b0b5cc; }
  .fh-sep  { color:#d8dce8; font-size:.8rem; }
  .fh-page { font-size:.82rem; color:#1a1d2e; font-weight:600; }
  .fh-right { display:flex; align-items:center; gap:8px; }
  .fh-icon-btn { width:36px; height:36px; border-radius:10px; border:1px solid #eaecf4; background:#f8f9fc; display:flex; align-items:center; justify-content:center; cursor:pointer; transition:background .15s; }
  .fh-icon-btn:hover { background:#f0f2f8; }
  .fh-icon-btn svg { width:17px; height:17px; stroke:#6b7194; stroke-width:1.7; }
  .fh-divider { width:1px; height:24px; background:#eaecf4; margin:0 4px; }
  .fh-user { display:flex; align-items:center; gap:10px; padding:5px 10px 5px 5px; border-radius:12px; cursor:pointer; transition:background .15s; border:1px solid transparent; }
  .fh-user:hover { background:#f5f6fb; border-color:#eaecf4; }
  .fh-avatar { width:32px; height:32px; border-radius:10px; background:linear-gradient(135deg,#0d9488,#0891b2); display:flex; align-items:center; justify-content:center; font-size:.75rem; font-weight:700; color:white; flex-shrink:0; }
  .fh-name { font-size:.8rem; font-weight:600; color:#1a1d2e; }
  .fh-role { font-size:.68rem; color:#9094a8; margin-top:2px; }
  .fh-user svg { width:14px; height:14px; stroke:#b0b5cc; stroke-width:2; margin-left:2px; }
  .fh-logout { padding:7px 14px; background:#f0fdfa; color:#0d9488; border:1px solid #99f6e4; border-radius:9px; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; transition:background .15s; }
  .fh-logout:hover { background:#ccfbf1; }
  .fh-hamburger { display:none; }
  @media (max-width:768px) {
    .fh { padding:0 16px; }
    .fh-hamburger { display:flex; }
    .fh-breadcrumb, .fh-sep { display:none; }
    .fh-name, .fh-role, .fh-user svg { display:none; }
    .fh-user { padding:4px; }
    .fh-divider { display:none; }
    .fh-logout { padding:6px 10px; font-size:.72rem; }
  }
`;

const getInitials = (name='') => name.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2) || 'F';

const FinanceHeader = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const displayName = user?.name || deriveNameFromEmail(user?.email) || 'Finance';
  return (
    <>
      <style>{headerStyle}</style>
      <header className="fh">
        <div className="fh-left">
          <button className="fh-icon-btn fh-hamburger" onClick={onMenuClick} style={{border:'none',background:'transparent'}}>
            <Bars3Icon />
          </button>
          <span className="fh-breadcrumb">School Portal</span>
          <span className="fh-sep">/</span>
          <span className="fh-page">Finance</span>
        </div>
        <div className="fh-right">
          <div className="fh-user">
            <div className="fh-avatar">{getInitials(displayName)}</div>
            <div>
              <div className="fh-name">{displayName}</div>
              <div className="fh-role">Finance Department</div>
            </div>
            <ChevronDownIcon />
          </div>
          <div className="fh-divider" />
          <button className="fh-logout" onClick={logout}>Logout</button>
        </div>
      </header>
    </>
  );
};

export default FinanceHeader;